import getters from "@/store/getters";

describe("getters", () => {
  const state = {
    route: "home",
    paso1: {
      nombre: "Lara",
      apellido: "Croft",
      email: "lara@gmail.com",
      celular: {
        area: "11",
        numero: "123123"
      },
      documento: {
        tipo: "DNI",
        numero: "35999888"
      }
    },
    formulario: {
      nombre: "Lara",
      apellido: "Croft",
      email: "lara@gmail.com",
      telefonoArea: "11",
      telefonoNumero: "123123",
      documentoTipo: "DNI",
      documentoNumero: "35999888"
    },
    consulta: ""
  };

  it("getRoute returns correct value", () => {
    const result = getters.getRoute(state)();
    expect(result).toEqual(state.route);
  });

  it("getConsulta returns correct value", () => {
    const result = getters.getConsulta(state)();
    expect(result).toEqual(state.consulta);
  });

  it("getPaso1 returns correct value", () => {
    const result = getters.getPaso1(state)();
    expect(result).toEqual(state.paso1);
  });

  it("getConfirmacionData returns correct value", () => {
    const result = getters.getConfirmacionData(state)();
    expect(result).toEqual(state.formulario);
  });
});
